import { useTranslateContext } from "fennec-ui";
import Icofont from "react-icofont";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router";
import { access } from "../../../../common/Tool";
import MenuLevelTwo from "../../../components/MenuLevelTwo";
import Main from "./Main";

const menu = (status, notify) => {
    const x = [
        {
            uuid: "main",
            default: true,
            name: "Главная",
            component: (props) => (<Main {...props}/>),
            role: [
                { "ID": 28, "nazvanie": "СуперАдмин" },
            ],
            icon: function () {
                return (<span className="anticon"><Icofont icon="home" /></span>)
            },
        }
    ]
    return x
};

export default function Admin(props) {
    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status);
    const notify = useSelector(state => state.home.notify);
    const t = useTranslateContext();

    return (<div className="subcontent">
        <div className={"content"}>
            <Routes>
                {menu(status, notify).map((e, idx) => {
                    if (e.default && access(e, role_by_id)) {
                        return <Route key={"index-" + e.uuid} index element={<Navigate replace to={e.uuid} />} />
                    }
                })}
                {menu(status, notify).map((e, idx) => {
                    if (e.component && access(e, role_by_id)) {
                        return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={e.component({
												level: {
													parent: props?.level,
													uuid: e?.uuid,
													name: e?.name,
													color: e?.color,
													role: e?.role,
                                                    hidden: e.hidden
												},
											  })} />
                    }
                })}
            </Routes>
        </div>
        <div className={"footer"}>
            <MenuLevelTwo menu={menu(status, notify)} />
        </div>
    </div>)
}